export default "__VITE_ASSET__DC1LG2HY__"